import React, {Fragment} from 'react';
import EligibilityTable from '../../../UI/DataTable/DataTable';
import Message from '../../../components/Message/Message';
import Button from '../../../UI/Button/Button';
import classes from './MemberEligibility.css';
import Spinner from '../../../UI/Spinner/Spinner';
import { EditIcon, RefreshIcon, ProcessingIcon, TrashIcon, RefreshIconDisable, LinkIcon, TrashIconDisabled } from '../../../UI/Icons/Icons';
import * as actions from '../../../store/actions/index';
import { connect } from 'react-redux';
import Modal from '../../../UI/Modal/Modal';
import MemberPortalInfo from '../../../components/MemberPortalInfo/MemberPortalInfo';
import DeleteEligConfirmation from '../../../components/DeleteEligibilityConfirmation/DeleteEligibilityConfirmation';
import RebuildCacheMyuhcPopUp from '../../../components/RebuildCache/RebuildCacheMyuhcPopUp';
import { maskSubscr, getPortalNameForEligibilityScreen, isPortalActive, isAccountDisabled, isAccountEnabled, checkSuperUser, getExternalLinkByPortalShortName, isExternalLinkDisabled, isPortalDisabled } from '../../../shared/utility';
import { QUICK_LINKS_ENABLE, SESSION_BASELINEAGENT, SESSION_SUPERUSER, SESSION_SUPERVISORUSER, SESSION_TIER1USER } from '../../../shared/Constants';
import { FEATURE_NOT_AVAILABLE_FOR_USER_MESSAGE } from '../../../shared/AdminToolMessages';
import { Link } from 'react-router-dom';

const memberEligibility = (props) => {

    //Member Eligibility table column mapping
    const resultColumnMapping = [
        {dataField: 'portalFirstNm', text: 'First Name'},
        {dataField: 'portalLastNm', text: 'Last Name'},
        {dataField: 'portalSubscriberId',
            text: 'Subscriber ID',
            events:{onClick: (e) => {
                const row = memberPortalList[e.currentTarget.title];
                props.modalHandler({...row, rebuild: null, view: null})}},
            title:(cell, row, rowIndex, colIndex)=>{
                return rowIndex;
            },
            classes: classes.DataLink},
        {dataField: 'portalSpecificMemberId',
            text: 'Member ID',
            events:{onClick: (e) => {
                const row = memberPortalList[e.currentTarget.title];
                props.modalHandler({...row, rebuild: null, view: null})}},
            title:(cell, row, rowIndex, colIndex)=>{
                return rowIndex;
            },
            classes: classes.DataLink},
        {dataField: 'portalPolicyNbr', text: 'Policy #'},
        {dataField: 'eligibilityInfo', 
            text: 'Eligibility Info',  
            style: {
                width: '12%',
            },
            headerStyle: {
                width: '12%'
            }
        },
        {dataField: 'portalDisplayName', text: 'Portal'},
        {dataField: 'rebuild',
            text: 'Rebuild',
            title:(cell, row, rowIndex, colIndex)=>{
                return rowIndex;
            },
            events: isAccountDisabled(props.memberData.essoData) ? null : {onClick: (e) => {
                const row = memberPortalList[e.currentTarget.title];
                if (isPortalDisabled(row.portalShortNm, props.disabledPortals))
                    return;
                return props.isNullHSID || props.isHeadlessUser || row.portalShortNm === "UHCPR" ?alert(FEATURE_NOT_AVAILABLE_FOR_USER_MESSAGE):row.portalShortNm==='MYUHC'?props.viewRebuildModalHandler({...row, rebuild: null, view: null}):isPortalActive(props.portals, row.portalShortNm)?props.rebuildCache({...row, rebuild: null, view: null, uuid: props.healthSafeId, userName: props.memberData.essoData.userName}):null
        }},
            headerAlign:'center',
            align:'center',
            classes: isAccountDisabled(props.memberData.essoData) ? classes.DisableLinkCol : classes.LinkCol,
            headerClasses: classes.LinkHeader,
            style: {
                width: '8%',
            },
            headerStyle: {
                width: '8%'
            }
        },
    ];

    //this is to make sure that the delete is only displayed to the super users.
    if (props.user && props.user.userType === SESSION_SUPERUSER) {
        resultColumnMapping.push(
            {dataField: 'delete',
                text: 'Delete Eligibility',
                events: isAccountDisabled(props.memberData.essoData) ? null : {onClick: (e) => {
                    const row = memberPortalList[e.currentTarget.title]
                    if (isPortalDisabled(row.portalShortNm, props.disabledPortals))
                        return;
                    props.isNullHSID || props.isHeadlessUser || row.portalShortNm === "UHCPR" ?alert(FEATURE_NOT_AVAILABLE_FOR_USER_MESSAGE):props.deleteModalHandler({...row, rebuild: null, view: null})}},
                headerAlign:'center',
                align:'center',
                classes: isAccountDisabled(props.memberData.essoData) ? classes.DisableLinkCol : classes.LinkCol,
                headerClasses: classes.LinkHeader,
                 style: {
                width: '8%',  
            },
            title:(cell, row, rowIndex, colIndex)=>{
                return rowIndex;
            },
            headerStyle: {
                width: '8%'
            }
            });
    }

    if (QUICK_LINKS_ENABLE) {
      resultColumnMapping.push({
        dataField: "externalLink",
        text: "Links",
        headerAlign: "center",
        align: "right",
        style: {
          width: "13.5%",
          fontSize: "15px",
        },
        headerStyle: {
          width: "13.5%",
        },
        headerClasses: classes.LinkHeader,
      });
    }

    const isOtpVerified = props.isOTPVerified ||(props.isNullHSID || (props.isHeadlessUser));
    if(
        props.memberData.memberPortalAttributeList === undefined ||
        props.memberData.memberPortalAttributeList === null || 
        props.memberData.memberPortalAttributeList.length === 0
    ){
        props.memberData.memberPortalAttributeList = [{"memberPortalId":0}]
    }
    let memberPortalList = props.memberData.memberPortalAttributeList?.map((portalRec, index) => {
        let linkMap = getExternalLinkByPortalShortName(portalRec.portalShortNm);
        return {
            ...portalRec,
            id: index,
            portalDisplayName: getPortalNameForEligibilityScreen(portalRec.portalShortNm, props.portals),
            portalShortNm: portalRec.portalShortNm,
            portalSubscriberId: portalRec.portalShortNm==="CAP" ? portalRec.portalSubscriberId: portalRec.portalSubscriberId ? maskSubscr(portalRec.portalSubscriberId) : '-',
            rebuild: portalRec.portalShortNm===props.cacheRebuildPortal?<ProcessingIcon id={index}/>:(isPortalActive(props.portals, portalRec.portalShortNm) && !isPortalDisabled(portalRec.portalShortNm, props.disabledPortals))?<div className={isOtpVerified? classes.rebuildTransparent: classes.rebuildEnabled}><RefreshIcon id={index}/></div>:<div><RefreshIconDisable id={index}/></div>,
            view: <EditIcon id={index} />,
            delete: isPortalDisabled(portalRec.portalShortNm, props.disabledPortals)?<TrashIconDisabled id={index}/>:<TrashIcon id={index}  />,
            externalLink: <div className={isOtpVerified? classes.linkTransparent: isExternalLinkDisabled(linkMap.mimicLink) ? '' : classes.linkEnabled}><div >Impersonate <Link className={linkMap.mimicLink ? classes.LinkCol : classes.DisableExternalLink} to={linkMap.mimicLink} target="_blank" rel="noopener noreferrer"><LinkIcon/></Link></div>
                {checkSuperUser(props.user.userType) ? <div>Policy <Link className={linkMap.viewPolicyLink ? classes.LinkCol: classes.DisableExternalLink} to={linkMap.viewPolicyLink} target="_blank" rel="noopener noreferrer"><LinkIcon/></Link> </div> : null}</div>,
            isSdkPortal: props.sdkPortalList && props.sdkPortalList.find(o => o.portalShortName === portalRec.portalShortNm) ? true : false,
            eligibilityInfo: props.sdkPortalList && (props.sdkPortalList.find(o => o.portalShortName === portalRec.portalShortNm) && portalRec.portalEligibilityResponse != null) ? portalRec.portalEligibilityResponse.eligibilityInfo.map(p => <div>{JSON.stringify(p)}</div>) : 'NA',
            portalSpecificMemberId: portalRec.portalSpecificMemberId ? portalRec.portalSpecificMemberId : '-',
            portalPolicyNbr: portalRec.portalPolicyNbr ? portalRec.portalPolicyNbr : '-'
        }
    });

    let form = (
        <EligibilityTable
            data={memberPortalList}
            columns={resultColumnMapping}
            clicked={(data)=>{}}
        />
    );

    const isUserEnabled = isAccountEnabled(props.memberData.essoData);

    let addEligButton = props.isNullHSID || (props.isHeadlessUser)?
    (props.user.userType === SESSION_SUPERUSER ||
        (props.isHeadlessUser && [SESSION_TIER1USER, SESSION_SUPERVISORUSER].includes(props.user.userType))
    ) && <div style={{display:'flex', justifyContent:'center', padding:'20px 0 10px 0'}}>
            <Button id="delete" btnType="Search" clicked={()=>{
                if(!isOtpVerified) {
                    return;
                }
                props.deleteAccount({provisionMemberId:props.provisionMemberId,uuid:props.healthSafeId,userName:props.memberData.essoData?.userName,emailId:props.memberData.essoData?.email?.value, secondaryEmail: props.memberData.essoData?.secondaryEmail?.value})
            }} disabled={false}>Delete HSID</Button>
        </div>:props.isHeadlessUser?null:(
        <div style={{display:'flex', justifyContent:'center', padding:'20px 0 10px 0'}}>
            <Button id="addEligibility" btnType="Search" clicked={()=>{
                if(!isOtpVerified) {
                    return;
                }
                props.showAddEligibility()
                }} disabled={!isUserEnabled}>Add/Modify Eligibility</Button>
        </div>);

    let displayMessage = null;
    if(props.message) {
        displayMessage = <Message msgType={props.message.type} info={props.message} />
    }
    if(props.delEligMessage) {
        displayMessage = <Message msgType={props.delEligMessage.type} info={props.delEligMessage} />
    }

    let mbrPrtlModal = (props.memberPortalData)? <Modal show={props.showModal} modalClosed={props.modalHandler}><MemberPortalInfo mbrPortalInfo={props.memberPortalData} portals={props.portals} memberData={props.memberData} idType={props.idType} isNullHSID={props.isNullHSID}/></Modal>: null;
    let mbrDelEligModal = (props.showDeleteEligModal || props.processing)? (
                            <Modal show={props.showDeleteEligModal || props.processing} modalClosed={props.deleteModalHandler}>
                                {props.processing?<Spinner/>:
                                <DeleteEligConfirmation 
                                    mbrPortalInfo={props.memberPortalData} 
                                    modalClosed={props.deleteModalHandler} 
                                    deleteEligibility={props.deleteEligibility}
                                    portals={props.portals}
                                />}
                            </Modal>
                        ):null;
    let rebuildModal = (!props.showRebuildMyuhcModal && props.rebuildProcessing)? (
                        <Modal show={props.rebuildProcessing}>
                            <Spinner/>
                        </Modal>
                        ):null;

    let myuhcRebuildModal = props.showRebuildMyuhcModal? (
                            <Modal show={props.showRebuildMyuhcModal} modalClosed={props.viewRebuildModalHandler}>
                                <RebuildCacheMyuhcPopUp 
                                    mbrPortalInfo={props.memberPortalData} 
                                    modalClosed={props.viewRebuildModalHandler} 
                                    rebuildCache={props.rebuildCache}
                                    uuid={props.healthSafeId}
                                    userName={props.memberData.essoData.userName}
                                />
                            </Modal>
                        ):null;

    
    const otpVerificaitonNotifier =  isOtpVerified ? null : <div className={classes.OTPMessageDiv}><Message msgType="Error" info={{ message: "Please verify Identity to edit."}} /></div>;
    return (
        <Fragment>
            {mbrPrtlModal}
            {mbrDelEligModal}
            {rebuildModal}
            {myuhcRebuildModal}
            {displayMessage}
            <div className={classes.EilgibilityHeader}>
                <div className={classes.EligibilityHeaderLeftEndDiv}></div>
                <h3 className={classes.EligibilityTitle}>{"Member Portal Eligibility"}</h3>
                {otpVerificaitonNotifier}
            </div>
            <div className={classes.EligibilityWrapper}>
                {isOtpVerified ? null : <div className={classes.EligibilityDisableLayer }></div>}
                {form}
                {props.user.userType !== SESSION_BASELINEAGENT && addEligButton}
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => {
    return {
        message: state.member.memberEligMsg,
        delEligMessage: state.member.deleteEligMsg,
        healthSafeId: state.member.member.healthSafeId,
        cacheRebuildPortal: state.member.rebuildCachePortal,
        memberPortals: state.member.member.memberPortalAttributeList,
        provisionMemberId: state.member.member.provisionMemberId,
        processing: state.member.processing,
        rebuildProcessing: state.member.rebuildProcessing,
        user: state.usr.user,
        portals: state.personalInfo.portals,
        disabledPortals: state.addEligibility.disabledPortals
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        rebuildCache: (memberPortalData) => dispatch(actions.rebuildCache(memberPortalData)),
        deleteAccount: (formData) => dispatch(actions.deleteAccount(formData, ownProps.history, "/search")),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(memberEligibility);